import axios from 'api';
import { getCurrentApiUrl } from 'app/helpers';

require('dotenv').config();

export const GET_COUNTRIES = '[CONSOLE] GET COUNTRIES';
export const GET_COUNTRIES_FOR_A_SPECIFIC_BRAND =
  '[CONSOLE] GET COUNTRIES FOR A SPECIFIC BRAND';

export function getCountries(locale) {
  const request = axios.get(`${getCurrentApiUrl()}/countries`, {
    params: {
      locale
    }
  });

  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_COUNTRIES,
          payload: response.data
        });
      })
      .catch(err => err);
}

export function getCountriesForSpecificBrand(id) {
  const request = axios.get(`${getCurrentApiUrl()}/countries?brand=${id}`);

  return dispatch =>
    request
      .then(response => {
        dispatch({
          type: GET_COUNTRIES_FOR_A_SPECIFIC_BRAND,
          payload: response.data
        });
      })
      .catch(err => err);
}
